export type ApiError = {
  data?: {
    Value?: string;
  };
};

export function indiaErrorHandler(err: ApiError) {
  let errorMessage: string | null = null;
  let isIndiaError = false;

  try {
    const errorValue = JSON.parse(err?.data?.Value ?? '{}');

    if (errorValue?.error?.toLowerCase().includes('india')) {
      isIndiaError = true;
      errorMessage = errorValue.error;
    } else if (errorValue?.error) {
      errorMessage = errorValue.error;
    }
  } catch (parseError) {
    console.error('Failed to parse error:', parseError);
  }

  return { errorMessage, isIndiaError };
}
